import React from 'react'
import Motivation from './component/Motivation'

const App = () => {
  return (
    <div>
    <Motivation />
    </div>
  )
}

export default App